<template>
    <div id="requested-information">
        <table class="table borderless">
            <tr>
                <td class="pl-0">{{ $t('Component(ReceivedRequestViewRequest):product-information-customer') }}</td>
                <td>{{ customer }}</td>
            </tr>
            <tr>
                <td class="pl-0">{{ $t('Component(ReceivedRequestSteps):requested-product') }}</td>
                <td>{{ productId }}, {{ productName }}</td>
            </tr>
            <tr>
                <td class="pl-0">{{ $t('Component(Label):last-response-date') }}</td>
                <td>{{ renderDate(request.validTo) }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import { BCard, BAlert } from 'bootstrap-vue'
import {getOurIdentifier, getOurName} from "@/libs/product";
import dateRenderer from "@core/mixins/date-renderer";
export default {
    mixins: [dateRenderer],
    components: {BCard, BAlert},
    props: {
        request: {
            required: true
        },
    },
    methods: {
        firstName() {
            if (this.request.product.names.length > 0) {
                return this.request.product.names[0].value;
            }
            return '';
        },
        firstId() {
            if (this.request.product.identifiers.length > 0) {
                return this.request.product.identifiers[0].value;
            }
            return '';
        }
    },
    computed: {
        dateRenderer() {
            return dateRenderer
        },
        customer() {
            if (this.request && this.request.customer) {
                return this.request.customer.title;
            }
            return '';
        },
        productId() {
            return getOurIdentifier(this.request.product) || this.firstId();
        },
        productName() {
            return getOurName(this.request.product) || this.firstName();
        },
    }
}
</script>

<style scoped>
#requested-information .borderless td, .borderless th {
    border: none;
}
#requested-information .borderless td {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
}
</style>
